import React from 'react';
import { Progress } from 'semantic-ui-react';
import styles from './progress.scss';
import { useLocation } from 'react-router-dom';
import { isMarketScanWaitingPage } from 'containers/layout/utils';

interface IProps {
  className?: string;
  progressBarClassName?: string;
  min?: number;
  percent?: number;
}
// TODO: REMOVE WHEN ALL NEW PRUCHASE FLOW IS IMPLEMENTED
const ProgressBar = ({
  className,
  progressBarClassName,
  percent,
  min = 0.5,
}: IProps) => {
  const location = useLocation();
  const marketScanWaitingPage = isMarketScanWaitingPage(location.pathname);
  return (
    <div
      className={classnames(
        styles.progress,
        className,
        marketScanWaitingPage && styles.msWaitingProgress,
      )}
    >
      <Progress
        className={classnames(
          styles.progressBar,
          progressBarClassName,
          marketScanWaitingPage && styles.msWaitingProgressBar,
        )}
        percent={percent || min}
        size="tiny"
      />
      <span>{percent}%</span>
    </div>
  );
};

export default ProgressBar;
